export default __webpack_public_path__ + "static/media/feet_clear.6d410278.png";